<template>
  <div class="w-full h-full flex flex-col max-sm:pb-[106px] overflow-auto">
    <user-info-box class="sm:hidden"></user-info-box>
    <div class="max-sm:hidden">
      <div class="flex flex-row justify-between items-center">
        <div class="left_logo">
          <div class="cursor-pointer w-44" @click="refreshPage">
              <img src="@/assets/logo.png" />
          </div>
        </div>
        <nav-bar></nav-bar>
      </div>
      <div class="text-center pb-10">
        <p class="select_title">MedliveGPT商业版本</p>
        <p class="select_tip">根据您的需求，选择相应的版本</p>
      </div>
    </div>
    <div class="vip_item_list">
      <vip-item-vue @selectVip="selectedVip"></vip-item-vue>
    </div>
    <div class="sm:hidden">
      <div class="vip_explain">
        <p>已开通会员，再次购买，有效期将在原有基础上顺延</p>
        <p>点击确认支付并付款则视为您已阅读并同意《会员服务协议》</p>
      </div>
      <div class="pay_explain">
        <p class="explain_title">支付说明：</p>
        <p>1.本品为数字产品，不支持7天无理由退款</p>
        <p>2.如有问题请联系客服：010-64405225</p>
      </div>
      <div class="btm_box">
        <div class="total_amount">合计：<span class="blue_num">¥{{ selectedItem.price ? selectedItem.price : '0.00'}}</span></div>
        <div class="pay_btn" @click="buyVip">立即购买</div>
      </div>
    </div>
  </div>

</template>

<script>
import UserInfoBox from "@/components/UserInfoBox.vue";
import NavBar from "@/components/NavBar.vue";
import VipItemVue from '@/components/VipItem.vue';

export default {
  components: {
    UserInfoBox,
    NavBar,
    VipItemVue
  },
  data() {
    return {
      selectedItem:{}
    };
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    refreshPage(){
      this.$router.push('/')
    },
    selectedVip(item){
      // console.log(item);
      this.selectedItem = item
    },
    buyVip() {
      if (this.selectedItem.price != 0) {
        let params = {
          token: window.localStorage.getItem('token'),
          member_id: this.selectedItem.id
        }
        this.$api.buyVipPlace(params).then(res => {
          console.log(res)
          window.location.href = res.data
        })
      } else {
        return
      }
    },
  }
};
</script>

<style lang='scss' scoped>
.left_logo{
  @apply ml-8;
}
.select_title{
  @apply mb-1 text-[28px] text-[#333333] leading-[39px] font-semibold;
}
.select_tip{
  @apply text-base text-[#333333];
}
.vip_item_list{
  @apply mb-3 px-4 flex justify-center;
}
.vip_explain{
  @apply mx-4 pb-5 text-[10px] text-[#A0A3AE] border-b-[1px] border-solid border-[#C2C4CB];
}
.pay_explain{
  @apply mx-4 pt-5 text-[10px] leading-[22px] text-[#333333] border-t-[1px] border-solid border-white;
  .explain_title{
    @apply text-xs leading-[22px];
  }
}
.btm_box{
  @apply w-full bg-white px-4 pt-[14px] pb-9 fixed bottom-0 flex justify-between items-center;
  .total_amount{
      @apply text-xs leading-[22px] text-black;
      .blue_num{
        @apply text-xl font-semibold text-[#4C5BDF];
      }
    }
    .pay_btn{
        @apply bg-[#4C5BDF] px-9 py-2 rounded-[10px] text-base text-white text-center;
    }
}
</style>
